import { useMutation } from "@tanstack/react-query";
import { DocumentService } from "../../../../services/document/document.service";

export const useUpdateDocumentInfo = () => {
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: any }) => {
      return DocumentService.updateFileInfo(id, body);
    },
  });
};
